import {
  SaveButton,
  Toolbar,
  DeleteButton,
  usePermissions,
  useRecordContext,
} from 'react-admin';
import { Box } from '@mui/material';
import { hasRole, type Permissions } from '../types';

export const ArchivalToolbar = () => {
  const { permissions } = usePermissions<Permissions>();
  const record = useRecordContext();

  return (
    <Toolbar sx={{ justifyContent: 'space-between' }}>
      <SaveButton />
      <Box>
        <SaveButton
          label={record?.archived_at ? 'Unarchive' : 'Archive'}
          variant="text"
          type="button"
          mutationOptions={{
            onSuccess: () => {},
          }}
          transform={(data: any) => ({
            ...data,
            archived_at: record?.archived_at
              ? null
              : new Date().toISOString(),
          })}
        />
        {hasRole(permissions, 'tenant_admin') && (
          <DeleteButton />
        )}
      </Box>
    </Toolbar>
  );
};
